import { motion } from "framer-motion";

/**
 * LegalLayout — shared shell for Privacy / Terms / Driver Consent.
 * Keeps typography and spacing consistent across all legal pages.
 */
export default function LegalLayout({ eyebrow, title, children }) {
  return (
    <div className="bg-[var(--lt-bg)]">
      <section data-lt-scheme="dark" className="relative py-14 md:py-20 bg-[color:var(--lt-navy)] border-b border-white/10">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}>
            <div className="font-mono-lt text-xs uppercase tracking-[0.3em] text-[var(--lt-accent-bright)] mb-3">{eyebrow}</div>
            <h1 className="font-display font-black text-4xl md:text-5xl uppercase text-white leading-none">{title}</h1>
          </motion.div>
        </div>
      </section>

      <section className="py-14 md:py-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <article
            className="legal-prose text-[color:var(--lt-text)] leading-relaxed"
            data-testid={`legal-${(title || "").toLowerCase().replace(/\s+/g, "-")}`}
          >
            {children}
          </article>
        </div>
      </section>
    </div>
  );
}
